import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Timer } from '../interfaces/timer.interface';
import { environment } from 'src/environments/environment';
import { Socket } from 'ngx-socket-io';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  constructor(private socket: Socket) {
    this.socket.connect();
  }

  emitEvent(event: string, timer: Timer): void {
    this.socket.emit(event, timer);
  }

  onEvent(event: string): Observable<Timer> {
    return new Observable((observer) => {
      this.socket.on(event, (data: Timer) => {
        observer.next(data);
      });

      return () => {
        this.socket.removeListener(event);
      };
    });
  }
}
